import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import styles from "./Analytics.module.css";
import { useDispatch } from "react-redux";
import { getpollanalytics } from "../../redux/actions/report.action";

const validationSchema = Yup.object({
  campaign_id: Yup.string().required("Campaign is required"),
  start_date: Yup.date().required("Start date is required"),
  end_date: Yup.date().required("End date is required"),
  enable_question: Yup.boolean(),
  question: Yup.string().when("enable_question", {
    is: (val) => val === true || val === "true",
    then: () => Yup.string().required("Question is required"),
    otherwise: () => Yup.string().notRequired(),
  }),
});




const ReportForm = ({setShowResult, showResult} ) => {
const dispatch = useDispatch();
const campaigns = [
  { label: "Plutos", id: "5" },
  { label: "Contest", id: "770b0bf8-fc1d-4bfe-b635-73d3197dcd30" },
];

  const handleSubmit = async (values, { setSubmitting , resetForm }) => {
    
    console.log("Form values:", values);
    
    try {
        if (!values.enable_question) {
        
          
          await dispatch(getpollanalytics(values));
          setShowResult(true);
        }else{   
        await dispatch(getpollanalytics(values));
       setShowResult(true);
        }

    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
    // resetForm();
  };


  return (
    <Formik
      initialValues={{
        campaign_id: "",
        question: "",
        start_date: "",
        end_date: "",
        enable_question: false,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, touched, errors, values, setFieldValue }) => (
        
        <Form className={styles.form}>
          <h3 className={styles.formheading}>
            Retrieve User Info and Registration Stats
          </h3>
          <div>
            <label>Campaign</label>
            <Field
              as="select"
              name="campaign_id"
              className={`${styles.input} ${
                touched.campaign_id && errors.campaign_id
                  ? styles.inputError
                  : ""
              }`}
            >
              <option value="">Select Campaign</option>
              {campaigns.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.label}
                </option>
              ))}
            </Field>
            {touched.campaign_id && errors.campaign_id && (
              <div className={styles.error}>{errors.campaign_id}</div>
            )}
          </div>

          <div>
            <label>
              <Field
                type="checkbox"
                name="enable_question"
                checked={values.enable_question}
                onChange={() =>
                  setFieldValue("enable_question", !values.enable_question)
                }
              />
              {" "}
              Do you want stats for a specific question? Select the checkbox below. Otherwise, proceed as usual.
            </label>
          </div>

          {values.enable_question && (
            <div>
              <label>Question</label>
              <Field
                type="text"
                name="question"
                className={`${styles.input} ${
                  touched.question && errors.question
                    ? styles.inputError
                    : ""
                }`}
              />
              {touched.question && errors.question && (
                <div className={styles.error}>{errors.question}</div>
              )}
            </div>
          )}

          <div>
            <label>Start Date</label>
            <Field
              type="date"
              name="start_date"
              className={`${styles.input} ${
                touched.start_date && errors.start_date
                  ? styles.inputError
                  : ""
              }`}
            />
            {touched.start_date && errors.start_date && (
              <div className={styles.error}>{errors.start_date}</div>
            )}
          </div>

          <div>
            <label>End Date</label>
            <Field
              type="date"
              name="end_date"
              className={`${styles.input} ${
                touched.end_date && errors.end_date
                  ? styles.inputError
                  : ""
              }`}
            />
            {touched.end_date && errors.end_date && (
              <div className={styles.error}>{errors.end_date}</div>
            )}
          </div>

          <button type="submit" disabled={isSubmitting}>
            Submit
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default ReportForm;
